import React from "react";
const CodeLinkLoader = () => (
  <div className="h3 w3 pa2 bg-white br2">
    <div className="shimmer w-100 h-100"></div>
  </div>
);

export default CodeLinkLoader;
